<script setup>

const props = defineProps({
  options: Object,
  course: Object
})
const config = useRuntimeConfig()
const { search, locationSearchDrawer, getLocationsByCords } = useLocationData()

const { $offcanvas } = useNuxtApp();
const { version } = useZigZag()
const { data, refresh } = await version(config.public.zigzagUrl)

const time = data.value ? data.value.t : 0;
const sha = data.value ? data.value.sha : 'versionnotfound';

const url = `${config.public.zigzagUrl}/app/layout/shell.html?sha=${sha}&t=${time}`;

const searchTerm = ref(null);
const bsOffcanvas = ref();
const locations = ref([]);
const otherLocations = ref([]);
const resultSlide = ref(true);
const resultsReady = ref(false)
const observer = ref()
const offcanvasStatus = ref(false)

const visitorStore = useVisitorStore();

const handleLocationSearch = (searchQuery) => {
  resultsReady.value = false;
  searchTerm.value = searchQuery;
}



const performSearch = async () => {
  if (searchTerm.value) {
    const {data: results, error } = await locationSearchDrawer (searchTerm.value);        
    
    locations.value = results.value.locationsWithinRadius.filter((location) => {
      return props.course.pulseCourse.locations.includes(location.pulseLocation.pulseId);
    });

    otherLocations.value = results.value.otherLocations.filter((location) => {
      return props.course.pulseCourse.locations.includes(location.pulseLocation.pulseId);
    });

    resultsReady.value = true;
  }
}

const openDrawer = async () => {
  performSearch();
  if (searchTerm.value) {    
    // bsOffcanvas.value.show();
    openOffcanvas();
  }
}

const searchMobile = async () => {
  resultsReady.value = false;
  performSearch();
}

const goToLocation = (locationId, courseId) => {
  resultSlide.value = false;
  location.href = `#/reg-flow/product-drawer?prodid=${courseId}&lid=${locationId}&style=default`;
}


const closeOffcanvas = () => {
  offcanvasStatus.value = false;
  resultSlide.value = true;
  document.body.style.overflow = 'visible';

  offcanvasStatus.value = false;
  document.body.style.overflow = 'visible';
}

const openOffcanvas = () => {
  offcanvasStatus.value = true;
  document.body.style.overflow = 'hidden';
}

const locationResultsClass = computed(() => {
  return {
    'd-block': resultSlide.value,
    'd-none': !resultSlide.value
  }
})

const spaResultsClass = computed(() => {
  return {
    'd-block': !resultSlide.value,
    'd-none': resultSlide.value
  }
})

const observeBackButton = () => {

  const observer = new MutationObserver((mutations, obs) => {
    const backButton = document.getElementById('idpDrawerTop');

    if (backButton) {
      backButton.addEventListener('click', () => {
        resultSlide.value = true;
      })
      return;
    }
  });

  observer.observe(document, {
    childList: true,
    subtree: true
  });
}


onMounted(() => {
  observeBackButton();
  bsOffcanvas.value = document.getElementById('miniavcDrawerSlider');

  window.addEventListener('hashchange', function () {
    // Checking if the URL hash changed and hiding the drawer in case the prod Id is not present
    if (!window.location.hash.includes('prodid')) {
      // resultSlide.value = true;
      closeOffcanvas();
    }
  });
})

const fields = props.options;

// Cheking for any custom field from the course collection
if (props.course.floatingBlock !== null) {
  if (props.course.floatingBlock.image && props.course.floatingBlock.image.data ) {    
    fields.image = props.course.floatingBlock.image.data.attributes;
  }
  if (props.course.floatingBlock.blockContent) {
    fields.blockContent = props.course.floatingBlock.blockContent;
  }
  if (props.course.floatingBlock.searchButton) {
    fields.searchButton = props.course.floatingBlock.searchButton;
  }
  if (props.course.floatingBlock.mobileButtonText) {
    fields.mobileButtonText = props.course.floatingBlock.mobileButtonText;
  }
  if (props.course.floatingBlock.noResultsAvailable) {
    fields.noResultsAvailable = props.course.floatingBlock.noResultsAvailable;
  }
  if (props.course.floatingBlock.subtext) {
    fields.subtext = props.course.floatingBlock.subtext;
  }
}

if (fields.image && fields.image.data.attributes && !fields.image.url) {
  fields.image.url = fields.image.data.attributes.url;
}


const getLocationDateRange = (location) => {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; 
  const from = new Date(new Date(location.pulseLocation.firstSessionStartDate).toLocaleString('en', {timeZone: 'UTC'}));
  const to = new Date(new Date(location.pulseLocation.lastSessionEndDate).toLocaleString('en', {timeZone: 'UTC'}));

  return `${monthNames[from.getMonth()]} ${from.getDate()} - ${monthNames[to.getMonth()]} ${to.getDate()}`;
}


const visitorData = {
  latitude: visitorStore.latitude,  
  longitude: visitorStore.longitude,  
  zipCode: visitorStore.zipCode,
  city: visitorStore.city,
  region: visitorStore.region,
  division: 'all',
  distance: 20000
};

if (visitorData.latitude !== 0 && visitorData.longitude !== 0 ) {
  const { data: geoLocations } = await getLocationsByCords(visitorData);

  if (config.public.nuxtEnvironment !== 'production') {
    console.log('Geolocation data without being filtered');
  }  
  
  if (geoLocations && geoLocations.value && geoLocations.value.length > 0) {
    locations.value = geoLocations.value.filter((location) => {    
      return props.course.pulseCourse.locations.includes(location.pulseLocation.pulseId) && location.distance <= 90;
    });
    
    otherLocations.value = geoLocations.value.filter((location) => {
      return props.course.pulseCourse.locations.includes(location.pulseLocation.pulseId) && location.distance > 90;
    });

    searchTerm.value = `${visitorData.city}, ${visitorData.region}`;
  }

    
}

const showLocations = async () => {
  if (locations.value.length > 0) {        
    resultSlide.value = true;
    resultsReady.value = true;     
    openOffcanvas();
  } else {
    location.href =  `#/reg-flow/product-drawer?prodid=${props.course.pulseCourse.pulseId}&style=default`;
    resultSlide.value = false;
    openOffcanvas();
  }
}

</script>

<template>
  
  <CourseBaseFloatingBlock>
    <template v-slot:block-body>
      <div class="extra-title">
        <NuxtImg :src="fields.image.url" class="card-image" v-if="fields" />
        <p class="fw-bold">{{ fields.blockContent }}</p>
        <div class="text-center">
          <button :class="`btn btn-primary`" @click="showLocations">{{ fields.buttonText }}</button>
        </div>
      </div>
    </template>
    <template v-slot:block-subtext>
      <div class="text-center mt-3" v-html="fields.subtext"></div>
    </template>
    <template v-slot:mobile-body>
      <button :class="`btn btn-primary w-100`" @click="showLocations">{{ fields.mobileButtonText }}</button>
    </template>
  </CourseBaseFloatingBlock> 

  <div class="offcanvas offcanvas-end www-drawer w-100" :class="{'show': offcanvasStatus}" id="miniavcDrawerSlider" tabindex="-1"  aria-labelledby="offcanvasLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasLabel"></h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" @click="closeOffcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <div class="location-results" :class="locationResultsClass">
        <div class="w-100">
          <a href="#" class="btn btn-text border-0 btn-drawer-text back-button" data-bs-dismiss="offcanvas" aria-label="Close" @click="closeOffcanvas">
            <span class="icon icon-left" aria-hidden="true"></span> Back to course page
          </a>
        </div>
        
        <div class="results px-4 mt-4">
          <div class="results-heading" v-if="locations.length > 0">
            <h6 class="mb-3">Locations near {{ searchTerm }}:</h6>            
            <legend class="py-2 mb-0 border-top border-bottom d-flex align-items-center">
              <span class="icon icon-day me-2"></span>Day Camp 
              <span class="icon icon-night ms-3 me-2"></span>Overnight Camp
            </legend>
          </div>
          <div class="results-body">
            <div class="" v-if="locations.length == 0 && otherLocations.length == 0 && resultsReady" v-html="fields.noResultsAvailable">
            </div>
            <button class="border-bottom border-start-0 border-top-0 border-end-0 bg-transparent w-100 py-3 px-0" @click="goToLocation(location.pulseLocation.pulseId, course.pulseCourse.pulseId)" v-for="location in locations">
              <div class="row align-items-center">
                <div class="col-8 col-xs-7 text-start">
                  <h6 class="mb-0">{{ location.pulseLocation.name }}</h6>
                  <p class="location-address mb-0">{{ location.pulseLocation.addressArea }}</p>
                  <div class="residency d-flex align-items-center">
                    <span>{{ getLocationDateRange(location) }}</span>
                    <span class="icon icon-day"></span>
                    <span class="icon icon-night" v-if="location.pulseLocation.residencyOption && location.pulseLocation.residencyOption.typeId == 356002"></span>                    
                  </div>
                </div>
                <div class="col-4 col-xs-5">                   
                  <div class="btn btn-primary w-100 btn-select">Select <span class="d-none d-md-inline">Location</span></div>
                </div>
              </div>
            </button>
          </div>

          <div class="results-heading futher-away mt-7 border-bottom py-3" v-if="otherLocations.length > 0">
            <h6 class="mb-3">{{ locations.length > 0 ? 'Locations further away' : 'Locations' }}</h6>
          </div>

          <div class="results-body" v-if="otherLocations.length > 0 && resultsReady">
            
            <button class="border-bottom border-start-0 border-top-0 border-end-0 bg-transparent w-100 py-3 px-0" @click="goToLocation(location.pulseLocation.pulseId, course.pulseCourse.pulseId)" v-for="location in otherLocations">
              <div class="row align-items-center">
                <div class="col-8 col-xs-7 text-start">
                  <h6 class="mb-0">{{ location.pulseLocation.name }}</h6>
                  <p class="location-address mb-0">{{ location.pulseLocation.addressArea }}</p>
                  <div class="residency d-flex align-items-center">
                    <span>{{ getLocationDateRange(location) }}</span>
                    <span class="icon icon-day"></span>
                    <span class="icon icon-night" v-if="location.pulseLocation.residencyOption && location.pulseLocation.residencyOption.typeId == 356002"></span>                    
                  </div>
                </div>
                <div class="col-4 col-xs-5">                   
                  <div class="btn btn-primary w-100 btn-select">Select <span class="d-none d-md-inline">Location</span></div>
                </div>
              </div>
            </button>
          </div>

        </div>
      </div>      
      <div id="www-spa-container" class="www-pulseapp mini-avc" :class="spaResultsClass" data-page="/reg-flow/product-availability">
        <div class="pulseapp">
          <AngularSpinner />
          <div class="shell-container" :ng-include="`'${url}'`">
              <div class="box-wrapper">
                <span class="spinner"></span>
                <strong>Loading...</strong>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas-backdrop fade" :class="{'show': offcanvasStatus, 'd-none': !offcanvasStatus}"></div>
  
</template>

<style lang="scss">

.location-results {
  h6 {
    font-weight: 600;
  }
  
  legend {
    font-size: 12px;
    border-color: #e0e0e0;
    color: $color-body-text;    
    .icon {
      color: #4c4c4c;
      font-size: 1rem;
    }
    
  }
  .residency {    
    font-size: 14px;
    color: #757575;

    .icon {
      line-height: inherit;
      margin-left: 5px;
    } 
    
  }
  button {
    .location-address {
      font-size: 14px;
      color: #757575;
    }
  }
  .btn-select {
    min-width: min-content;
    padding: 8px 20px;
    &:active {
      border-width: inherit;
    }
  }
  .location-status {
    &--open {
      color: #30ad3e;
    }

    &--no-dot::before {
      display: none;
    }

    &--coming-soon {
      color: #aa9314 !important;
    }

    &--waitlist {
      color: #ad307d !important;
    }

    &[class*="--coming-"]:not([class*="soon"]) {
      color: #a37070 !important; 
    }
  }
  .results-heading {
    h6 {
      font-size: 1.25rem;
    }
  }
  
}

.offcanvas {
  transition: all 0.8s ease-in-out;
  box-shadow: -0.5rem 0 1rem rgba(0, 0, 0, 0.5);

  .offcanvas-body {
    .back-button {
      font-size: 14px;      
    }
  }
}

.www-drawer {
  max-width: 650px;
  // Temporary styles to avoid conflicts with ZigZag  
  .www-pulseapp  {
    .btn {
      border: none;
      text-decoration: none;
      .text-nowrap {
        font-weight: 400;
      }
      .btn-pill-lg {
        padding: 0.8rem 2rem 0.8rem 2rem;
        font-size: 0.75rem;
      }
    }
    .btn-close {
      width: auto;
      background: none;
      color: inherit;
      
    }  
  }
  
}




</style>